import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import MobilePlanForm from '../forms/MobilePlanForm'
import ThingsToKnow from './ThingsToKnow'
import PaymentInformation from './PaymentInformation'
import { SERVICE_MOBILE, SERVICE_MOBILE_BROADBAND, SERVICE_WIRELESS } from '../constants'
import globals from '../globals'

const mapTypeToTerms = {
    [SERVICE_MOBILE]: 'changePlanMobile',
    [SERVICE_MOBILE_BROADBAND]: 'changePlanMobileBroadband',
    [SERVICE_WIRELESS]: 'changePlanWireless'
}

const mapTypeToCis = {
    [SERVICE_MOBILE]: 'https://files.exetel.com.au/cis/mobile/4G_ExeSim_Month_Month_2G19_20200206.pdf',
    [SERVICE_MOBILE_BROADBAND]: 'https://files.exetel.com.au/cis/mbb/EXE0087_4G_MBB_052019.pdf',
    [SERVICE_WIRELESS]: 'https://files.exetel.com.au/cis/hwbb/EXE0086_CIS_HomeWirelessBroadband_V3.pdf'
}

const mapTypeToTermsUrl = {
    [SERVICE_MOBILE]: 'https://www.exetel.com.au/mobilephone/terms',
    [SERVICE_MOBILE_BROADBAND]: 'https://www.exetel.com.au/mobile-broadband/terms',
    [SERVICE_WIRELESS]: 'https://www.exetel.com.au/broadband/home-wireless/terms'
}

const mapTypeToDescription = {
    [SERVICE_MOBILE]: 'Changing your SIM-only Mobile Plan is free. Your plan change will take effect on the 1st day of the following month, as long as you have submitted your change request  before the 27th of the month. You’ll also keep your current contract end-date and terms if you have one, or stay month-to-month if you don’t.',
    [SERVICE_MOBILE_BROADBAND]: 'Changing your Mobile Broadband plan is free. Your plan change will take effect on the 1st day of the following month, as long as you have submitted your change request  before the 27th of the month. You’ll also keep your current contract end-date and terms if you have one, or stay month-to-month if you don’t.',
    [SERVICE_WIRELESS]: 'Changing your plan is free. Even if you are still within your contract term, you can switch to a plan of higher or lower value without being hit with a plan-change fee. You’ll also keep your current contract end-date and terms if you have one, or stay month-to-month if you don’t.'
}

const mapTypeToUpgradeNotice = {
    [SERVICE_MOBILE]: 'As your SIM-only mobile service contract has not yet expired, you can only switch to a plan of higher value. Your change plan options are listed below.',
    [SERVICE_MOBILE_BROADBAND]: 'As your SIM-only mobile broadband service contract has not yet expired, you can only switch to a plan of higher value. Your change plan options are listed below.'
}

class ChangePlanMobile extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            plans: []
        }
    }

    componentDidMount () {
        DataSource.getData(`/api/getMobilePlans/${this.props.serviceId}`, result => {
            this.setState({
                plans: result.plans,
                isLoaded: true
            })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    handleSuccess (response, state) {
        globals.pushEvent('MobilePlanChangeSubmit', { planName: state.planObj.title })
    }

    render () {
        return (
            <div>
                <div className='module'>
                    <Heading title={this.props.title} />
                    <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError}>
                        <div className='p-4'>
                            <div className='row'>
                                <div className='col-12 col-md-8 offset-md-2 text-center'>
                                    <p>{mapTypeToDescription[this.props.type]}</p>
                                    {this.props.serviceDetails.inContract && this.props.type !== SERVICE_WIRELESS
                                        ? <p className='font-italic'>{mapTypeToUpgradeNotice[this.props.type]}</p>
                                        : ''}
                                </div>
                            </div>
                            <MobilePlanForm
                                plans={this.state.plans}
                                type={this.props.type}
                                serviceId={this.props.serviceId}
                                serviceDetails={this.props.serviceDetails}
                                cisUrl={mapTypeToCis[this.props.type]}
                                termsUrl={mapTypeToTermsUrl[this.props.type]}
                                handleSuccess={this.handleSuccess.bind(this)}
                            />
                        </div>
                    </ModuleWithLoader>
                </div>
                {this.state.plans.length > 0
                    ? <React.Fragment>
                        <PaymentInformation />
                        <ThingsToKnow type={mapTypeToTerms[this.props.type]} />
                      </React.Fragment>
                    : ''}
            </div>
        )
    }
}

ChangePlanMobile.propTypes = {
    type: PropTypes.oneOf([SERVICE_MOBILE, SERVICE_MOBILE_BROADBAND, SERVICE_WIRELESS]),
    serviceId: PropTypes.number.isRequired,
    serviceDetails: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired
}

export default ChangePlanMobile



// WEBPACK FOOTER //
// ./resources/js/modules/ChangePlanMobile.js